// ----------------------------------------------------------------------

export const paths = {
  // Marketing
  marketing: {
    root: '/marketing',
    services: '/marketing/services',
    caseStudies: '/marketing/case-studies',
    caseStudy: `/marketing/case-study`,
    posts: '/marketing/posts',
    post: `/marketing/post`,
    about: '/marketing/about',
    contact: '/marketing/contact',
  },
  // Travel
  travel: {
    root: '/travel',
    tours: '/travel/tours',
    tour: `/travel/tour`,
    checkout: '/travel/checkout',
    orderCompleted: '/travel/order-completed',
    posts: '/travel/posts',
    post: `/travel/post`,
    about: '/travel/about',
    contact: '/travel/contact',
  },
  // Career
  career: {
    root: '/career',
    jobs: '/career/jobs',
    job: `/career/job`,
    posts: '/career/posts',
    post: `/career/post`,
    about: '/career/about',
    contact: '/career/contact',
  },
  // E-learning
  eLearning: {
    root: '/e-learning',
    courses: '/e-learning/courses',
    course: `/e-learning/course`,
    posts: '/e-learning/posts',
    post: `/e-learning/post`,
    about: '/e-learning/about',
    contact: '/e-learning/contact',
  },
  // E-commerce
  eCommerce: {
    root: '/',
    products: '/san-pham',
    product: `/san-pham`,
    productAdd: '/them-san-pham',
    details: (id: string) => `/san-pham/${id}`,
    cart: '/gio-hang',
    checkout: `/thanh-toan`,
    orderCompleted: '/dat-hang-thanh-cong',
    wishlist: `/danh-sach-yeu-thich`,
    compare: `/so-sanh`,
    account: {
      root: `/tai-khoan`,
      personal: `/tai-khoan/ca-nhan`,
      wishlist: `/tai-khoan/yeu-thich`,
      vouchers: `/tai-khoan/ma-giam-gia`,
      orders: `/tai-khoan/don-hang`,
      payment: `/tai-khoan/thanh-toan`,
    },
  },
  // Auth
  login: '/dang-nhap',
  loginCover: '/auth/login-cover',
  loginBackground: '/auth/login-background',
  loginIllustration: '/auth/login-illustration',
  registerCover: '/auth/register-cover',
  registerBackground: '/auth/register-background',
  registerIllustration: '/auth/register-illustration',
  forgotPassword: '/auth/forgot-password',
  verify: '/auth/verify',
  // Common
  maintenance: '/maintenance',
  comingsoon: '/coming-soon',
  pricing01: '/pricing-01',
  pricing02: '/pricing-02',
  payment: '/payment',
  support: '/support',
  page404: '/404',
  page500: '/500',
  // Components
  components: {
    root: '/components',
    animate: '/components/animate',
    carousel: '/components/carousel',
    countUp: '/components/count-up',
    form: '/components/form-validation',
    icons: '/components/icons',
    image: '/components/image',
    label: '/components/label',
    lightbox: '/components/lightbox',
    markdown: '/components/markdown',
    megaMenu: '/components/mega-menu',
    navigation: '/components/navigation-bar',
    scroll: '/components/scroll',
    player: '/components/player',
    textMaxLine: '/components/text-max-line',
  },
  // Others
  pages: '/pages',
  docs: 'https://zone-docs.vercel.app',
  license: 'https://material-ui.com/store/license/#i-standard-license',
  minimalStore: 'https://material-ui.com/store/items/minimal-dashboard',
  zoneStore: 'https://mui.com/store/items/zone-landing-page/',
  figmaPreview:
    'https://www.figma.com/file/X6OyiGHF8dnTk3aT38P0oN/%5BPreview%5D-Zone_Web.30.03.23?node-id=0-1',
  // Custom pages
  aboutUs: '/ve-chung-toi',
  contact: '/lien-he',
  classroomSolutions: '/giai-phap-phong-hoc',
};
